export default __webpack_public_path__ + "static/media/No1Open.2aa134fe.jpg";